import React from "react";
import { Localize } from "components/service";
import StaffManagementFields from "../fields";
import { adaptEvent } from "./staff-events-api-helper";


const staffManagementColumns = [
    {
        title: <Localize>STAFF_MANAGEMENT.Column_Exhibition</Localize>,
        dataIndex: "title",
        columnIndex: "TITLE",
        width: 275,
    },
    {
        title: <Localize>STAFF_MANAGEMENT.Column_Status</Localize>,
        dataIndex: "status",
        width: 180,
    },
    {
        title: <Localize>STAFF_MANAGEMENT.Column_Construction</Localize>,
        dataIndex: "construction",
        width: 193,
    },
    {
        title: <Localize>STAFF_MANAGEMENT.Column_ExhibitionPeriod</Localize>,
        dataIndex: "exhibitionPeriod",
        width: 190,
    },
    {
        title: <Localize>STAFF_MANAGEMENT.Column_Workers</Localize>,
        dataIndex: "workers",
        width: 145,
    },
    {
        title: <Localize>STAFF_MANAGEMENT.Column_Subcontractors</Localize>,
        dataIndex: "subcontractors",
        width: 194,
    },
    {
        dataIndex: "qr",
        align: "right",
        width: 120,
    },
];

const staffManagementData = (events = []) => events.map((apiEvent) => {
    const event = adaptEvent(apiEvent);

    return {
        key: event.id,
        title: <StaffManagementFields.EventLink id={ event.id } title={ event.title } />,
        status: <StaffManagementFields.Status status={ event.lifecycle_status } />,
        construction: (
            <StaffManagementFields.Period
                startAt={ event.constructionStart_at }
                endAt={ event.constructionEnd_at } />
        ),
        exhibitionPeriod: (
            <StaffManagementFields.Period
                startAt={ event.start_at }
                endAt={ event.end_at } />
        ),
        workers: (
            <StaffManagementFields.Workers
                count={ event.workers_count }
                onSiteCount={ event.workers_on_site_count } />
        ),
        subcontractors: (
            <StaffManagementFields.Subcontractors
                count={ event.subcontractors_count }
                subcontractors={ event.subcontractors } />
        ),
        qr: <StaffManagementFields.Qr event={ event } />,
    };
});

const StaffManagementTableHelper = {
    columns: staffManagementColumns,
    data: staffManagementData,
};

export default StaffManagementTableHelper;
